<template>
  <div class="">
    <b-button variant="light" @click="editProfile()" class="mb-3">Edit Profile</b-button>
    <b-button variant="light" @click="searchLinkedIn()" class="mb-3 ml-3">Find on LinkedIn</b-button>
    <b-table-simple>
      <b-tbody>
        <b-tr>
          <b-td>
            Name
          </b-td>
          <b-td>
            {{member.name}}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            Email
          </b-td>
          <b-td>
            {{member.email}}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            Phone
          </b-td>
          <b-td>
            {{member.phone}}
          </b-td>
        </b-tr>

        <b-tr v-for="answer in memberAnswers" :key="answer.question">
          <b-td>
            {{answer.question}}
          </b-td>
          <b-td>
            {{answer.answer}}
          </b-td>
        </b-tr>

      </b-tbody>
    </b-table-simple>
    <b-modal ref="edit-profile-modal" title="Edit Profile" ok-title="Save" @ok="save" :busy="saving">
      <b-form-group label="Name">
        <b-form-input v-model="member.name"></b-form-input>
      </b-form-group>
      <b-form-group label="Email">
        <b-form-input v-model="member.email"></b-form-input>
      </b-form-group>
      <b-form-group label="Phone">
        <b-form-input v-model="member.phone"></b-form-input>
      </b-form-group>
    </b-modal>

  </div>
</template>
<script>
import {UpdateProfile} from '@/gql/members/Members.gql';

export default {
    props: {
        member: {
            type: Object,
            required: true
        }
    },
    data () {
      return {
        saving: false
      }
    },
    methods: {
      editProfile() {
        this.$refs['edit-profile-modal'].show();
      },
      async save(evt) {
        evt.preventDefault(); // Prevent from closing automatically
        this.saving = true;
        await this.$apollo.mutate({
          mutation: UpdateProfile,
          variables: {
            id: this.member.id,
            email: this.member.email,
            name: this.member.name,
            phone: this.member.phone
          }
        });
        this.saving = false;
        this.$refs['edit-profile-modal'].hide();
      },
      searchLinkedIn() {
        const query = `${this.member.name} inurl:linkedin.com/in`;
        window.open('https://www.google.com/search?q=' + encodeURIComponent(query), '_blank');
      }
    },
    computed:{
      memberAnswers() {
        return this.member.profile ? Object.values(this.member.profile) : [];
      }
    }
}
</script>
